import {Camera, CONSTANTS, MATRIX4} from '../../index.js';

/**
 * Creates Hypercube.js perspective cameras.
 * @example
 * const cameraperspective = new CameraPerspective(name, options);
 */
class CameraPerspective extends Camera {

    /**
     * Stores the field of view in degrees.
     * @type {number}
     * @private
     */
    $angle;

    /**
     * Stores the distance to the far clipping plane.
     * @type {number}
     * @private
     */
    $far;

    /**
     * Stores the distance to the near clipping plane.
     * @type {number}
     * @private
     */
    $near;

    /**
     * Stores the type.
     * @type {string}
     * @protected
     */
    $type = 'camera.perspective';

    /**
     * Gets the projection matrix of the camera.
     * @type {matrix4}
     * @public
     * @readonly
     */
    get projection() {

        return MATRIX4.perspective(this.$angle, this.$aspect, this.$near, this.$far);
    }

    /**
     * Creates a new Hypercube.js perspective camera.
     * @param {string} $name The name of the perspective camera.
     * @param {object} $options The options of the perspective camera.
     * @param {number} $options.angle The field of view in degrees.
     * @param {number} $options.far The distance to the far clipping plane.
     * @param {number} $options.near The distance to the near clipping plane.
     */
    constructor($name, $options) {

        super($name);

        this.$angle = $options.angle * CONSTANTS.RADIANS;
        this.$aspect = 1;
        this.$far = $options.far;
        this.$near = $options.near;
    }
}

export {

    CameraPerspective
};

export default CameraPerspective;
